// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/participants.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/participants.proto.
 */
export const file_pull_requests_v1_participants: GenFile = /*@__PURE__*/
  fileDesc("CiNwdWxsX3JlcXVlc3RzL3YxL3BhcnRpY2lwYW50cy5wcm90bxIXZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEiZwoUUGFydGljaXBhbnRzUmVzcG9uc2USOgoMcGFydGljaXBhbnRzGAEgAygLMiQuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuUGFydGljaXBhbnQSEwoLdG90YWxfY291bnQYAiABKAUiaAoLUGFydGljaXBhbnQSCgoCaWQYASABKAMSFQoNZGlzcGxheV9sb2dpbhgCIAEoCRISCgphdmF0YXJfdXJsGAMgASgJEhQKDHByb2ZpbGVfcGF0aBgEIAEoCRIMCgRzbHVnGAUgASgJYgZwcm90bzM");

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/participants
 *
 * Defined by PullRequests::PageData::SharedController#participants.
 *
 * @generated from message github.pull_requests.v1.ParticipantsResponse
 */
export type ParticipantsResponse = Message<"github.pull_requests.v1.ParticipantsResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.Participant participants = 1;
   */
  participants: Participant[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message github.pull_requests.v1.ParticipantsResponse.
 * Use `create(ParticipantsResponseSchema)` to create a new message.
 */
export const ParticipantsResponseSchema: GenMessage<ParticipantsResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_participants, 0);

/**
 * @generated from message github.pull_requests.v1.Participant
 */
export type Participant = Message<"github.pull_requests.v1.Participant"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string display_login = 2;
   */
  displayLogin: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: string profile_path = 4;
   */
  profilePath: string;

  /**
   * @generated from field: string slug = 5;
   */
  slug: string;
};

/**
 * Describes the message github.pull_requests.v1.Participant.
 * Use `create(ParticipantSchema)` to create a new message.
 */
export const ParticipantSchema: GenMessage<Participant> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_participants, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(ParticipantsResponseSchema, "243c8ff3c350")
registerSchemaHash(ParticipantSchema, "42742ab620d1")
